import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cbfa5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lambda-create-edit-form" }
const _hoisted_2 = { class: "card-header-text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "form-container" }
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = { class: "pull-frequency-container" }
const _hoisted_9 = { class: "toggle-container" }
const _hoisted_10 = { class: "input-field-container" }
const _hoisted_11 = { class: "monitoring-container" }
const _hoisted_12 = { class: "tags-container py-4" }
const _hoisted_13 = { class: "tag-condition-radio-button" }
const _hoisted_14 = { class: "tags-inputs" }
const _hoisted_15 = { class: "card-footer" }

import RexCardV3 from '@/rex-components/RexCardV3.vue';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import RexSwitchV3 from '@/rex-components/RexSwitchV3.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexFormInput from '@/rex-components/rex-modal-input.vue';
import { CSSProperties, computed, onMounted, ref, watch } from 'vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import { rdsServiceCreateEditFormRadioGroupOptions } from '@/components/Cloud/Dashboard/cloud.types';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import RexRadioV3 from '@/rex-components/RexRadioV3.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import { isEmpty, isEqual } from 'lodash';
import { useRoute } from 'vue-router';
import { notificationError, notificationSucess } from '@/utils/notification';
import { useI18n } from 'vue-i18n';
import { useAwsServiceDetails } from '@/components/Cloud/Hooks/useAwsServiceDetails';
import { useFetchGlobalFrequency } from '@/components/Cloud/Hooks/useFetchGlobalFrequency';
import { useUpdateServiceInfo } from '@/components/Cloud/Hooks/useAwsUpdateServiceInfo';
import { useInstallAwsServicesManually } from '@/components/Cloud/Hooks/useInstallAwsServicesManually';
import { Props, TypeCondition } from './FormTypes';

// TODO: get this from constant file after merging with ingress

export default /*#__PURE__*/_defineComponent({
  __name: 'ElastiCacheCreateEditForm',
  props: {
    type: {}
  },
  emits: ['updateAllServices', 'close'],
  setup(__props: any, { emit: __emit }) {

const initData = {
  pullFrequency: '',
  global: false,
  enableMonitoring: false,
  globalPullFrequencyMins: '',
  tagsCondition: '',
  tags: [{}] as { key: string; value: string }[],
};

const props = __props;
const emit = __emit;
const { params } = useRoute();
const { t } = useI18n();
const {
  data: serviceInfo,
  fetchAwsServiceDetails,
  isLoading: isAwsServiceInfoLoading,
} = useAwsServiceDetails();
const {
  data: globalPullFrequencyMins,
  fetchGlobalFrequency,
  isLoading: isFetchGlobalFrequencyLoading,
} = useFetchGlobalFrequency();
const { updateServiceInfo, isLoading: isUpdateServiceInfoLoading } =
  useUpdateServiceInfo();
const { installServiceManually, isLoading: isManuallyInstallLoading } =
  useInstallAwsServicesManually();

const isEdit = computed(() => props.type === TypeCondition.EDIT);

const isLoading = computed(
  () =>
    isFetchGlobalFrequencyLoading.value ||
    isAwsServiceInfoLoading.value ||
    isUpdateServiceInfoLoading.value ||
    isManuallyInstallLoading.value,
);

// TODO: get this from constant file after merging with ingress
const getCardBodyStyle = computed(
  (): CSSProperties => ({
    height: '420px',
    width: '100%',
    padding: '1.25rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }),
);

const radioGroupOptions = rdsServiceCreateEditFormRadioGroupOptions;

const userInputs = ref({ ...initData });
const initialValue = ref({ ...initData });
const errorState = ref({
  isPullFrequencyValueError: false,
  isPullFrequencyValidationError: false,
});

const handleIsGlobalToggling = (toggleValue) => {
  userInputs.value.global = toggleValue;
  userInputs.value.pullFrequency = userInputs.value.globalPullFrequencyMins;
};

const handleMonitorToggeling = (toggleValue) => {
  userInputs.value.enableMonitoring = toggleValue;
};

const submitFrom = async (submitAction, payload) => {
  await submitAction(payload);

  notificationSucess(
    props.type === TypeCondition.EDIT
      ? t('aws.elasticCacheServiceUpdated')
      : t('aws.awselasticacheConfiguredSuccessfully'),
  );
  emit('updateAllServices', 'elasticache', userInputs.value.enableMonitoring);
};

const isFormValid = () => {
  errorState.value = {
    isPullFrequencyValueError: false,
    isPullFrequencyValidationError: false,
  };

  if (
    isNaN(parseInt(userInputs.value.pullFrequency)) ||
    userInputs.value.pullFrequency?.includes?.('.') ||
    userInputs.value.pullFrequency?.includes?.('-')
  ) {
    errorState.value.isPullFrequencyValidationError = true;
    return false;
  }

  if (
    userInputs.value.pullFrequency === '0' ||
    !userInputs.value.pullFrequency
  ) {
    errorState.value.isPullFrequencyValueError = true;
    return false;
  }

  return true;
};

watch(serviceInfo, (currentValue) => {
  const tempData = JSON.stringify({
    ...currentValue,
  });

  userInputs.value = JSON.parse(tempData);
  initialValue.value = JSON.parse(tempData);
});

watch(globalPullFrequencyMins, (currentValue) => {
  if (currentValue.success) {
    userInputs.value.globalPullFrequencyMins =
      currentValue.globalPullFrequencyMins.toString();
    userInputs.value.pullFrequency =
      currentValue.globalPullFrequencyMins.toString();
    userInputs.value.enableMonitoring = true;
    userInputs.value.global = true;
    userInputs.value.tagsCondition = 'AND';
  }
});

const getInitialData = async () => {
  try {
    if (props.type === TypeCondition.EDIT) {
      fetchAwsServiceDetails('elasticache');
    } else {
      fetchGlobalFrequency();
    }
  } catch {
    notificationError(t('aws.formSubmissionFailed'));
  }
};

const handleSaveClick = () => {
  if (!isFormValid()) return;
  if (props.type === TypeCondition.EDIT) {
    submitFrom(updateServiceInfo, {
      subscriptionId: params.subscriptionId,
      serviceSlug: 'elasticache',
      meta: {},
      pullFrequencyMins:
        userInputs.value.pullFrequency ||
        userInputs.value.globalPullFrequencyMins,
      isGlobalEnabled: userInputs.value.global,
      tagsCondition: userInputs.value.tagsCondition,
      isMonitoringEnabled: userInputs.value.enableMonitoring,
      tags:
        Object.keys(userInputs.value.tags[0]).length > 0
          ? userInputs.value.tags.filter((tag) => !isEmpty(tag))
          : [],
    });
  } else {
    submitFrom(installServiceManually, {
      isAutoInstall: false,
      serviceSlug: 'elasticache',
      subscriptionId: params.subscriptionId,
      meta: {},
      tags:
        Object.keys(userInputs.value.tags[0]).length > 0
          ? userInputs.value.tags.filter((tag) => !isEmpty(tag))
          : [],
      tagsCondition: userInputs.value.tagsCondition,
      pullFrequencyMins:
        userInputs.value.pullFrequency ||
        userInputs.value.globalPullFrequencyMins,
      isMonitoringEnabled: userInputs.value.enableMonitoring,
    });
  }
};

onMounted(() => {
  getInitialData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RexSpinV3, { spinning: isLoading.value }, {
      default: _withCtx(() => [
        _createVNode(RexCardV3, { bodyStyle: getCardBodyStyle.value }, {
          title: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              (isEdit.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('aws.awsElasticacheEditForm')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('aws.awsElasticache')), 1))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(RexModalLabel, {
                      primaryLabelStyle: {
                    color: userInputs.value.global ? 'rgba(89, 90, 89, 1)' : 'white',
                  },
                      primaryLabel: _ctx.$t('aws.rdsFormFields.pullFrequency')
                    }, null, 8, ["primaryLabelStyle", "primaryLabel"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.$t('aws.rdsFormFields.global')) + " ", 1),
                      _createVNode(RexSwitchV3, {
                        onOnChange: handleIsGlobalToggling,
                        checked: userInputs.value.global,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((userInputs.value.global) = $event))
                      }, null, 8, ["checked"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(RexFormInput, {
                      modelValue: userInputs.value.pullFrequency,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInputs.value.pullFrequency) = $event)),
                      type: "text",
                      id: "input-pull-frequency",
                      disabled: userInputs.value.global
                    }, null, 8, ["modelValue", "disabled"]),
                    (
                    userInputs.value.pullFrequency &&
                    errorState.value.isPullFrequencyValidationError &&
                    userInputs.value.pullFrequency !== '0'
                  )
                      ? (_openBlock(), _createBlock(RexInfoLabel, {
                          key: 0,
                          isError: true,
                          info: 
                    _ctx.$t(
                      'aws.createNewConfigguration.errorState.inValidPullFrequency',
                    )
                  
                        }, null, 8, ["info"]))
                      : _createCommentVNode("", true),
                    (errorState.value.isPullFrequencyValueError)
                      ? (_openBlock(), _createBlock(RexInfoLabel, {
                          key: 1,
                          isError: true,
                          info: _ctx.$t('aws.rdsFormFields.errorState.noPullFrequency')
                        }, null, 8, ["info"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(_ctx.$t('aws.rdsFormFields.enableMonitoring')) + " ", 1),
                  _createVNode(RexSwitchV3, {
                    size: "small",
                    onOnChange: handleMonitorToggeling,
                    checked: userInputs.value.enableMonitoring,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((userInputs.value.enableMonitoring) = $event))
                  }, null, 8, ["checked"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(RexModalLabel, {
                      primaryLabel: _ctx.$t('aws.rdsFormFields.tags')
                    }, null, 8, ["primaryLabel"]),
                    _createVNode(RexRadioV3, {
                      class: "tags-condition",
                      modelValue: userInputs.value.tagsCondition,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userInputs.value.tagsCondition) = $event)),
                      options: _unref(radioGroupOptions)
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userInputs.value.tags, (currentTag, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "tag-input-group"
                      }, [
                        _createVNode(RexFormInput, {
                          class: "tag-input",
                          modelValue: currentTag.key,
                          "onUpdate:modelValue": ($event: any) => ((currentTag.key) = $event),
                          type: "text",
                          id: "input-tag-key"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(RexFormInput, {
                          class: "tag-input",
                          modelValue: currentTag.value,
                          "onUpdate:modelValue": ($event: any) => ((currentTag.value) = $event),
                          type: "text",
                          id: "input-tag-value"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (index + 1 !== userInputs.value.tags.length)
                          ? (_openBlock(), _createBlock(RexButtonV3, {
                              key: 0,
                              type: "primary",
                              danger: "",
                              variant: "primary",
                              id: "remove-tag",
                              onOnClick: ($event: any) => (userInputs.value.tags.splice(index, 1)),
                              class: "tag-button"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(BaseIcon, {
                                  height: "0.938rem",
                                  width: "0.938rem",
                                  name: "deleteFilled"
                                })
                              ]),
                              _: 2
                            }, 1032, ["onOnClick"]))
                          : _createCommentVNode("", true),
                        (index + 1 === userInputs.value.tags.length)
                          ? (_openBlock(), _createBlock(RexButtonV3, {
                              key: 1,
                              variant: "primary",
                              id: "add-tag",
                              onOnClick: ($event: any) => (
                      currentTag.key &&
                        currentTag.value &&
                        userInputs.value.tags.push({} as any)
                    ),
                              class: "tag-button"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(BaseIcon, {
                                  height: "0.938rem",
                                  width: "0.938rem",
                                  name: "plus"
                                })
                              ]),
                              _: 2
                            }, 1032, ["onOnClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (
                _ctx.$emit(
                  'close',
                  props.type === _unref(TypeCondition).EDIT ? 'edit' : 'manualInstall',
                )
              )),
                  id: "cancel",
                  class: "cancel-button"
                }, _toDisplayString(_ctx.$t('aws.createNewConfigguration.cancel')), 1),
                _createVNode(RexButtonV3, {
                  onOnClick: handleSaveClick,
                  id: "save",
                  variant: 
                _unref(isEqual)(initialValue.value, userInputs.value) ? 'disabled' : 'primary'
              
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('aws.createNewConfigguration.save')), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["bodyStyle"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})